import map_icon from './../images/location-mark-orange.png';
import map_icon_sm from './../images/location-mark-orange-sm.png';
import orte_data from "./../../assets/data/wp_ort.json";
import * as L from 'leaflet';
import * as L1 from 'leaflet.markercluster';
$(document).on('turbo:load', function() {
    $(document).ready(function() {
        var mo_icon = L.icon({
            iconUrl: map_icon,
            iconSize: [35, 35],
        });
        let poi_element_ = $("#poi-map-");
        if (poi_element_.length > 0) {
            var poi_map = L.map('poi-map-').setView([poi_element_.data("lat"), poi_element_.data("lng")], 18);
            L.tileLayer('https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png?{foo}', { foo: 'bar' }).addTo(poi_map);
            L.marker([poi_element_.data("lat"), poi_element_.data("lng")], { icon: mo_icon , draggable: true, autoPan: true}).addTo(poi_map)
                .bindPopup(`<p class='mb-0 fw-bold mt-0'>${poi_element_.data("name")}</p><p class='fs-small mt-0'>${poi_element_.data("address")}</p>`).openPopup();
        }
        let event_element_ = $("#event-map");
        if (event_element_.length > 0) {
            var event_map = L.map('event-map').setView([event_element_.data("lat"), event_element_.data("lng")], 16);
            L.tileLayer('https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png?{foo}', { foo: 'bar' }).addTo(event_map);
            L.marker([event_element_.data("lat"), event_element_.data("lng")], { icon: mo_icon }).addTo(event_map)
                .bindPopup(event_element_.data("address"))
        }
        let location_picker_element_ = $("#location_picker_map");
        if (location_picker_element_.length > 0) {
            var location_map = L.map('location_picker_map').setView([location_picker_element_.data("lat"), location_picker_element_.data("lng")], 13);
            L.tileLayer('https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png?{foo}', { foo: 'bar' }).addTo(location_map);
            var marker = L.marker([location_picker_element_.data("lat"), location_picker_element_.data("lng")], { icon: mo_icon }).addTo(location_map);
            location_map.on('click', function(e) {
                if (marker)
                    location_map.removeLayer(marker);
                marker = L.marker(e.latlng, { icon: mo_icon }).addTo(location_map);
                $.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${e.latlng.lat}&lon=${e.latlng.lng}`, function (data) {
                    const address = data.address;
                    const _link = `https://maps.google.de/maps?saddr=My+Location&daddr=${data.lat},${data.lon}`;
                    $("#error_address_route").val(_link);
                    const street = address.road ||
                                   address.pedestrian ||
                                   address.residential ||
                                   address.neighbourhood ||
                                   '';
                    const houseNumber =
                      address.house_number ||
                      address.housenumber ||
                      (address.name && (address.name.match(/\b\d+[a-zA-Z]?\b/) || [])[0]) ||
                      '';

                    $("input#error_address_street").val(`${street}`.trim());
                    $("input#error_address_house_number").val(`${houseNumber}`.trim());
                    $("input#error_address_zip").val(`${address.postcode || ''}`);
                    $("input#error_address_city").val(`${address.village || address.town || address.city || ''}`);
                });
            });
        }
        $("#view-map-btn").click(function() {
            let root_element_ = $("#poi_list_map");
            if (root_element_.height() < 1) {
                root_element_.css("height", "750px");
                $("#poi_list:not([class*='d-none'])").addClass("d-none");
                $("#poi_loaded_list:not([class*='d-none'])").addClass("d-none");
                $("#view-map-btn").html('\n<div class="icon-seo-search"></div>\n<span class="ps-2 text-decoration-underline fs-small">Auf der Liste anzeigen</span>\n')
            } else {
                root_element_.css("height", "0");
                $("#view-map-btn").html('\n<div class="icon-maps-search"></div>\n<span class="ps-2 text-decoration-underline fs-small">Auf der Karte anzeigen</span>\n');
                $("#poi_list").removeClass("d-none");
                $("#poi_loaded_list").removeClass("d-none");
            }
            if (root_element_.length > 0) {
                var container = L.DomUtil.get('poi_list_map');
                if (container != null) {
                    container._leaflet_id = null;
                }
                var poi_list_map = L.map('poi_list_map').setView([$("#poi_list > li").data("coordinates")["lat"], $("#poi_list > li").data("coordinates")["lon"]], 12);
                // var poi_list_map = L.map('poi_list_map').setView([$("#poi_list > li").data("coordinates")["lat"], $("#poi_list > li").data("coordinates")["lon"]], $("select#poi_list_umk option:selected").val());
                var mo_icon = L.icon({
                    iconUrl: map_icon,
                    iconSize: [35, 35],
                });
                L.tileLayer('https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png?{foo}', { foo: 'bar' }).addTo(poi_list_map);
                var markersCluster = new L1.MarkerClusterGroup({ showCoverageOnHover: false });
                $("#poi_list > li").each(function() {
                    var my_marker = L.marker([$(this).data("coordinates")["lat"], $(this).data("coordinates")["lon"]], { icon: mo_icon }).bindPopup(`<img src='${$(this).data("logo")}' style='width: 40px; margin-right: 5px;'><a class='link-dark text-decoration-none' href='${$(this).data("link")}'>${$(this).data("title")}</a>`)
                    markersCluster.addLayer(my_marker);
                })
                $("#poi_loaded_list > li").each(function() {
                    var my_marker = L.marker([$(this).data("coordinates")["lat"], $(this).data("coordinates")["lon"]], { icon: mo_icon }).bindPopup(`<img src='${$(this).data("logo")}' style='width: 40px; margin-right: 5px;'><a class='link-dark text-decoration-none' href='${$(this).data("link")}'>${$(this).data("title")}</a>`)
                    markersCluster.addLayer(my_marker);
                })
                poi_list_map.addLayer(markersCluster);
            }
        });
    })
});
